import React from 'react';

import { Box, HStack } from '@rbilabs/universal-components';

import { DELIVERY_PROGRESS_COLOR } from './constants';

const barMargin = '45px';
const ProgressBarLine = HStack.withConfig({
  position: 'absolute',
  top: barMargin,
  left: barMargin,
  right: barMargin,
  height: '$1',
});

const CompleteSegment = Box.withConfig({
  backgroundColor: DELIVERY_PROGRESS_COLOR,
});

const RemainingSegment = Box.withConfig({
  backgroundColor: Styles.color.grey.four,
});

interface ProgressBarProps {
  percentComplete: number;
}

const ProgressBar: React.FC<React.PropsWithChildren<ProgressBarProps>> = ({
  percentComplete = 0,
}) => {
  return (
    <ProgressBarLine>
      <CompleteSegment width={`${percentComplete}%`} />
      <RemainingSegment width={`${100 - percentComplete}%`} />
    </ProgressBarLine>
  );
};

export default ProgressBar;
